import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

export function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged cookies
    const cookieConsent = localStorage.getItem('marketbloom_cookie_consent');
    if (!cookieConsent) {
      setShowBanner(true);
    } else {
      // Enable analytics scripts
      enableAnalytics();
    }
  }, []);

  const enableAnalytics = () => {
    // This is where you would enable Google Analytics, Meta Pixel, etc.
    // For example:
    // window.gtag('consent', 'update', {
    //   'analytics_storage': 'granted'
    // });
    console.log('Analytics enabled');
  };

  const acceptCookies = () => {
    localStorage.setItem('marketbloom_cookie_consent', 'accepted');
    enableAnalytics();
    setShowBanner(false);
  };

  const dismissBanner = () => {
    localStorage.setItem('marketbloom_cookie_consent', 'dismissed');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto md:max-w-lg">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <p className="text-sm text-gray-700 leading-relaxed">
              We use cookies to improve your experience and analyze site usage. 
              <a 
                href="/privacy" 
                className="text-brand-primary hover:underline ml-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </p>
          </div>
          <button
            onClick={dismissBanner}
            className="text-gray-400 hover:text-gray-600 flex-shrink-0"
            aria-label="Dismiss cookie notice"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="mt-3 flex gap-2">
          <Button
            onClick={acceptCookies}
            className="bg-[#967F81] hover:bg-[#843329] text-white text-sm px-4 py-2 h-auto"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
} 